/* eslint-disable max-len */
export const partners = [
  {
    width: 225,
    logo: '/Images/barometer/unian-logo.png',
    title: 'Головний медіа-партнер',
    text1: 'УНІАН – найстаріше та найбільше інформаційне агентство України, засноване 1993 року, лідер ринку інформаційних послуг в Україні. ',
    text2: 'Вебсайт unian.ua є найпопулярнішим новинним веб-сайтом UA-нету, також компанія володіє найбільшим українським сервісом новинних фото, одним з найпопулярніших телеграм-каналів нашої держави і великою мережею інформаційних сторінок у Фейсбуці.',
    text3: 'YouTube-канал UNIAN входить до топ-5 найпопулярніших українських новинних YouTube-проектів.',
  },
  {
    width: 300,
    logo: '/Images/barometer/raiff-logo.png',
    title: 'Експертний партнер',
    text1: '«Райффайзен Банк» - найбільший іноземний кредитор українського бізнесу та лідер з наданої гуманітарної та благодійної допомоги серед українських банків.',
    text2: 'У Райфі понад 5 500 співробітників пліч-о-пліч щодня працюють, щоб 2,65 мільйона наших клієнтів могли отримати якісне обслуговування, користуватися продуктами і сервісами банку, розвивати бізнес, адже ми #Разом_з_Україною.',
    text3: '«Ти маєш значення» – слоган бренду роботодавця банку, адже люди – це наш головний актив, і ми даємо їм підтримку і визнання, навчаємо та залучаємо до змін.',
  },
  {
    width: 300,
    logo: '/Images/barometer/fora-logo.png',
    title: 'Експертний партнер',
    text1: '«Фора» – це мережа продуктових магазинів поблизу дому, яка успішно працює на ринку України з 2002 року. Мережа налічує понад 340 магазинів у десяти регіонах України.',
    text2: '«Фора» має власні розподільчі центри та виробничі цехи, а також власні торгові марки «Зірковий вибір» і Favore. Розвиває інтернет-магазин fora.ua, а також мобільний застосунок із персоніфікованою програмою лояльності.',
    text3: 'Щодня «Фора» піклується про понад 450 тисяч гостей і дев\'ять тисяч співробітників. Як роботодавець мережа відкрита для всіх, кому важливі стабільний дохід та перспективи розвитку. «Фора» – робота, потрібна людям.',
  },
  {
    width: 300,
    logo: '/Images/barometer/darnytsa-logo.png',
    title: 'Експертний партнер',
    text1: 'Фармацевтична компанія «Дарниця», заснована у 1930 році, є лідером на фармацевтичному ринку України за обсягом продажів лікарських засобів. ',
    text2: 'Успіх компанії базується на лідерстві кожного співробітника на своєму місці. Команда з понад 1200 професіоналів працює над тим, щоб забезпечити людей ліками нового покоління і покращити якість життя та здоров’я. ',
    text3: 'У «Дарниці» приділяють особливу увагу турботі про співробітників та їхні родини, створюючи умови для розвитку та гідної винагороди, що дозволяє компанії регулярно бути в рейтингах найкращих роботодавців України.',
  },
];
